export function generarCURPEsperada(nombre: string, apellidoPaterno: string, apellidoMaterno: string, fechaNacimiento?: string, sexo?: string): string {
	// Extraer letras necesarias
	const primeraLetraPaterno = apellidoPaterno[0]
	const primeraVocalInternaPaterno = apellidoPaterno.slice(1).match(/[AEIOU]/i)?.[0] || 'X'
	const primeraLetraMaterno = apellidoMaterno[0] || 'X'
	const primeraLetraNombre = nombre.match(/^[A-ZÑ]/i)?.[0] || 'X'

	// Fecha de nacimiento
	if (fechaNacimiento) {
		const [anio, mes, dia] = fechaNacimiento.split('-')
		const fechaCURP = `${anio.slice(2)}${mes}${dia}`
		return `${primeraLetraPaterno}${primeraVocalInternaPaterno}${primeraLetraMaterno}${primeraLetraNombre}${fechaCURP}${sexo}`.toUpperCase()
	}
	return `${primeraLetraPaterno}${primeraVocalInternaPaterno}${primeraLetraMaterno}${primeraLetraNombre}`.toUpperCase()
}
export function esFechaValida(fecha?: Date): boolean {
	if ((fecha ?? undefined) == undefined) {
		return true
	}
	const hoy: Date = new Date()
	hoy.setHours(0, 0, 0, 0)

	const fechaComparar: Date = new Date(fecha!)
	fechaComparar.setHours(0, 0, 0, 0)
	return fechaComparar.getTime() < hoy.getTime()
}

export const regexCurp =
	/^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
